import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_follow_project_button = _resolveComponent("follow-project-button")

  return (_openBlock(), _createBlock(_component_follow_project_button, {
    section: "project-timeline",
    "project-id": $options.projectId,
    "project-name": $options.projectName
  }, {
    default: _withCtx(({ onSubscribe}) => [
      _createElementVNode("button", {
        class: "_tc--accent _pa-0 _ttl _tal",
        onClick: onSubscribe
      }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectTimelineFollowActionLabel), 9 /* TEXT, PROPS */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["project-id", "project-name"]))
}